
// Define the type for the parsed CSV data
interface CSVData {
  [key: string]: string; // Keys are column headers, values are row values
}

// Function to fetch and parse CSV data
export const fetchCSVData = async (csvPath: string,delimiter:string): Promise<CSVData[]> => {
  const response = await fetch(csvPath);
  if (!response.ok) {
    throw new Error(`Failed to fetch CSV file: ${response.statusText}`);
  }

  const text = await response.text();

  // Split the CSV into rows and columns
  const [headerLine, ...rowLines] = text.split("\n");
  const headers = headerLine.split(delimiter).map((header) => header.trim());

  // Map rows into objects
  return rowLines
    .filter((line) => line.trim() !== "") // Ignore empty lines
    .map((line) => {
      const values = line.split(delimiter).map((value) => value.trim());
      return headers.reduce((acc, header, index) => {
        acc[header] = values[index] || ""; // Use empty string if a value is missing
        return acc;
      }, {} as CSVData);
    });
};

